import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=af50435a&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=af50435a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af50435a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VContainer,VIcon,VProgressLinear,VSheet,VSnackbar})
